import React, {useEffect, useState} from "react";
import Header from "../../components/Header";
import OrderIdle from "../../components/OrderIdle";
import "./style.scss";
import {MenuItemCombination} from "../../@types/stores/menu";
import CombinationItem from "../../components/CombinationItem";
import {useParams} from "react-router";
import menuStore from "../../stores/menu";
import FooterForCombinations from "../../components/FooterForCombinations";
import orderStore from "../../stores/order";

const CombinationPage = () => {
    let params = useParams()

    const [item, setItem] = useState<MenuItemCombination | null>(null);
    const [stepId, setStepId] = useState<number>(-1);

    useEffect(() => {
        getItem(params.id)
    }, [params.id, params.stepId]);

    const getItem = async (id: string | undefined) => {
        if (!menuStore.menu)
            await menuStore.getMenu();

        const category = params.category ? +params.category : 0;
        menuStore.changeCategory(category);

        const subCategory = params.subCategory ? +params.subCategory : 0;
        menuStore.changeSubCategory(subCategory);


        if (id) {
            const _item = menuStore.getCombinationById(+id);
            if (_item) {
                let _stepId = params.stepId ? +params.stepId : _item.combination[0].id;
                setStepId(_stepId);
                setItem(_item);
                menuStore.changeMenuItem(_item.id);

                // package -> all articles of all steps are always included
                if (_item.isPackage)
                    orderStore.fillPackageCombinationOrderLine(_item, category, subCategory);
                // if combo with fixed price -> add for showing price in footer
                else if (!!_item.price)
                    orderStore.addArticleToCurrentCombinationOrderLine(_item);
            }
        }
    }

    if (!item) return null;

    return <div className="CombinationPage">
        <Header/>
        <CombinationItem item={item} menuId={+(params.category || 0)} subMenuId={+(params.subCategory || 0)}
                         stepId={stepId}/>
        <FooterForCombinations />
        <OrderIdle />
    </div>
}

export default CombinationPage;
